var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"xDQTfr-H8GDIp7Sr3J77T"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["inspire@inspire-3d"]={id:"xDQTfr-H8GDIp7Sr3J77T"};
      